module.exports = __webpack_public_path__ + "img/icon-question-rating-like.969ab4e5.svg";